import React from 'react';
import { Menu } from 'lucide-react';
import { Sheet, SheetTrigger } from '../../../components/ui/sheet';
import { MobileMenuContent } from './MobileMenuContent';
import { CurrentPage } from '../../../types';

interface MobileNavbarProps {
  currentPage: CurrentPage;
  onNavigate: (page: CurrentPage) => void;
}

/**
 * Mobile Navbar Trigger component.
 * SOLID: Responsibility is providing the entry point for mobile navigation.
 */
export const MobileNavbar: React.FC<MobileNavbarProps> = ({ 
  currentPage, 
  onNavigate 
}) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          title="Abrir menú"
          className="p-2 mr-2 rounded-xl bg-gray-50 text-gray-600 hover:bg-gray-100 md:hidden transition-all duration-200 border border-gray-100 active:scale-95"
        >
          <Menu className="h-6 w-6" />
        </button>
      </SheetTrigger>
      <MobileMenuContent 
        currentPage={currentPage} 
        onNavigate={onNavigate} 
      />
    </Sheet>
  );
};
